/**
 * @generated SignedSource<<96deb3edfc66b809e7ebdfd1b7f7a32b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly effectiveClientClass: ClientClass | null | undefined;
  readonly user: {
    readonly id?: string;
  } | null | undefined;
  readonly " $fragmentType": "DurationBasedAgendaFragment_session";
};
export type DurationBasedAgendaFragment_session$key = {
  readonly " $data"?: DurationBasedAgendaFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaFragment_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveClientClass",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "MemberUser",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "9ebccdd4c9d4a68a7cf452bb0f223fec";

export default node;
